import { getStorageUrl } from "@/supabase/storage";

function sanitizeFilename(name: string) {
  return name.replace(/[/\\:*?"<>|]/g, "_");
}

export function buildGallerySlide(
  photo: {
    storagePath: string;
    filename: string;
    caption: string | null;
    photographer: string | null;
  },
  index: number,
  tournamentName: string,
) {
  return {
    src: getStorageUrl("tournament_gallery_photos", photo.storagePath),
    alt: photo.caption || photo.filename,
    title: photo.caption ?? undefined,
    description: photo.photographer
      ? `Photo by ${photo.photographer}`
      : undefined,
    download: {
      url: getStorageUrl("tournament_gallery_photos", photo.storagePath),
      filename: sanitizeFilename(
        `${tournamentName} - ${index + 1}.${photo.storagePath.split(".").pop()}`,
      ),
    },
  };
}
